









import { Component, Vue } from "vue-property-decorator";
import DashboardDokter from "@/components/dashboard/DashboardDokter.vue";
import TrenKunjunganDokter from "@/components/dashboard/TrenKunjunganDokter.vue";
import DashboardDokterStore from "@/store/modules/DashboardDokterStore";
import { userModule } from "@/store/modules/user";
import { daftarPasienRouteName } from "@/utils/unit";

@Component({
  components: {
    DashboardDokter,
    TrenKunjunganDokter
  }
})
export default class DashboardDokterPage extends Vue {
  get isDpjp(): boolean {
    return !!userModule.user?.map_cdoc;
  }

  created() {
    if (!this.isDpjp) {
      this.$router
        .replace({ name: daftarPasienRouteName(userModule.user?.unit_id) })
        .catch(() => undefined);
    }
  }

  beforeDestroy() {
    DashboardDokterStore.reset();
  }
}
